import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const StorySection = () => {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    fetch("Sadstories.json") // Adjust this path if you store the JSON elsewhere
      .then((res) => res.json())
      .then((data) => setStories(data))
      .catch((err) => console.error("Failed to load stories:", err));
  }, []);

  return (
    <>
      <section id="stories" className="bg-gray-100 py-16 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">
            Stories that shine and the stories that need "you" to shine!
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {stories.map((story, idx) => (
              <div
                key={idx}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
              >
                <img
                  src={story.image}
                  alt={story.name}
                  className="w-full h-48 object-cover"
                />
                <div className="p-5 text-left">
                  <h3 className="text-xl font-semibold text-purple-700">{story.name}</h3>
                  <p className="text-sm text-gray-600 italic">{story.title}</p>
                  <p className="mt-3 text-gray-700 text-sm">{story.description}</p>
                  <Link
                    to={`/stories/${story.slug}`}
                    className="mt-4 inline-block text-purple-600 hover:text-purple-800 font-medium text-sm"
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default StorySection;
